import { Text } from "@chakra-ui/react";
import { isDemoEnvironment } from "../../constants/environment";

export default function DemoBadge() {
  if (!isDemoEnvironment()) {
    return null;
  }

  return <Text className="header-nova-text">Demo</Text>;
}
